import { z } from 'zod';

export const dataIconSchema = z.object({
  src: z.string().max(350_000).regex(/^data:image\/png;base64,[A-Za-z0-9+/]+={0,2}$/),
  width: z.number().int().min(1).max(512),
  height: z.number().int().min(1).max(512),
  scale: z.number().min(0).max(8),
  anchor: z.tuple([z.number().min(0).max(1), z.number().min(0).max(1)]),
  heading: z.number().min(0).max(360),
  color: z.string().regex(/^#[0-9a-f]{6}$/i),
  opacity: z.number().min(0).max(1),
}).strict().refine((icon) => Math.max(icon.width, icon.height) * dataIconScale(icon) <= 1024, 'Rendered icons must fit within 1024 pixels.');

export type DataIcon = z.infer<typeof dataIconSchema>;

export function dataIconScale(icon: { width: number; height: number; scale: number }): number {
  return icon.scale * 32 / Math.min(icon.width, icon.height);
}
